import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { AppStoreDispatcher } from '../state/app.state.dispatcher';
import { collection, deleteDoc, doc, Firestore, getDocs, query, Query, updateDoc, where, DocumentReference, getDoc } from '@angular/fire/firestore';
import { ProfileStateDispatcher } from '../state/profile/profile.dispatcher';
import { take } from 'rxjs/operators';
import { ApiService } from '../backend/api.service';

export enum FriendRequestStatusType {
    ACCEPTED = 'Accepted',
        PENDING = 'Pending',
        FOLLOWING = 'Following',
}


@Injectable({
    providedIn: 'root'
})
export class FriendRequestsService {

    constructor(
        public cloudFNs: Functions,
        public appStateDispatch: AppStoreDispatcher,
        public firestore: Firestore,
        public profileDispatch: ProfileStateDispatcher,
        public apiService: ApiService,
    ) {}

    /**
     * Load user's friend requests
     */
    public async loadFriendRequests(): Promise < any > {
        const myID = await this.profileDispatch.getMyID();
        return getDocs(this.getUserContactsCollection(myID, FriendRequestStatusType.FOLLOWING))
            .then(async (querySnapshot) => {
                return getDocs(this.getUserContactsCollection(myID, FriendRequestStatusType.ACCEPTED))
                    .then(myFriendDocs => {
                        const promises: any[] = [];
                        querySnapshot.forEach(doc => {
                            const userID = doc.data().userID;
                            promises.push(
                                // tslint:disable-next-line: max-line-length
                                getDocs(this.getUserContactsCollection(userID ,FriendRequestStatusType.ACCEPTED))
                                .then(async (userFriendDocs) => {
                                    const myFriends = myFriendDocs.docs.map((myFriendDoc) => myFriendDoc.data().userID);
                                    const userFriends = userFriendDocs.docs.map((userFiendsDoc) => userFiendsDoc.data().userID);
                                    const mutualContacts = myFriends.filter(friend => userFriends.indexOf(friend) !== -1);
                                    return getDoc(this.getUserID(userID)).then((userDoc) => {
                                        return { ...userDoc.data(), mutualContacts };
                                    });
                                })
                            );
                        });
                        return Promise.all(promises).then(invitations => {
                            return invitations;
                        });
                    });
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                };
            });
    }

    getUserContactsCollection(ID: string, friendShipStatus: string): Query<any> {
        const collectionReference = collection(this.firestore, `users/${ID}/contacts`) as Query<any>;
        const collectionQuery = query(collectionReference, where('status', '==', friendShipStatus));
        return collectionQuery;
    }

    getUserContactsDoc(userID: string, myID: string) {
        return doc(this.firestore, `users/${userID}/contacts/${myID}`)
    }

    getUserID(userID: string) {
        return doc(this.firestore, `users/${userID}`) as DocumentReference<any>;
    }

    /**
     * Accept friend request
     * @param userID the user's uid
     */
    public async acceptFriendRequest(userID: string): Promise < any > {
        const myID = await this.profileDispatch.getMyID();
        return Promise.all([
            // Update user's node friend requst info
            updateDoc(this.getUserContactsDoc(userID, myID), {
                status: FriendRequestStatusType.ACCEPTED
            }),
            // Update my node friend requst info
            updateDoc(this.getUserContactsDoc(myID, userID), {
                status: FriendRequestStatusType.ACCEPTED
            })
        ]).then(() => {
            this.apiService.acceptFriendRequest({ senderID: myID, friendID: userID }).then(result => {
                // Read result of the Cloud Function.
                console.log(result);
            }).catch(error => {
                // Getting the Error details.
                const code = error.code;
                const message = error.error;
                const details = error.details;
                console.log(error);
            });
        }).catch(error => {
            console.error(error);
            return {
                success: false,
                error: error
            };
        });
    }


    /**
     * Deny friend request
     * @param userID The user's uid
     */
    public async denyFriendRequest(userID: string): Promise < any > {
        const myID = await this.profileDispatch.getMyID();
        return Promise.all([
            // Delete user's node friend requst info
            deleteDoc(this.getUserContactsDoc(userID, myID)).then(() => {
                console.log('Document successfully deleted!');
            }),
            // Delete my node friend requst info
            deleteDoc(this.getUserContactsDoc(myID, userID)).then(() => {
                console.log('Document successfully deleted!');
            })
        ]).then(() => {
            this.apiService.denyFriendRequest({ senderID: myID, friendID: userID }).then(result => {
                // Read result of the Cloud Function.
                console.log(result);
            }).catch(error => {
                // Getting the Error details.
                const code = error.code;
                const message = error.error;
                const details = error.details;
                console.log(error);
            });
        }).catch(error => {
            console.error(error);
            return {
                success: false,
                error: error
            };
        });
    }
}
